import { useRef, useCallback, useMemo } from 'react'
import get from 'lodash/get'
import set from 'lodash/set'

const useAsyncCache = (initial) => {
  const cacheAsync = useRef(initial ?? {})

  const getAsync = useCallback(async (key, _default) => {
    return await get(cacheAsync.current, key, Promise.resolve(_default))
  }, [])

  // i want to set promise immediately
  // - for subsequence [get] for this key is called suddenly.
  //   So subsequence [get] will await a same promise instance surely.
  const setAsync = useCallback((key, resolvePromise) => {
    if (resolvePromise && resolvePromise instanceof Promise) {
      set(cacheAsync.current, key, resolvePromise)
      return;
    }

    let resolve, reject;
    const promise = new Promise((rs, rj) => {
      resolve = rs
      reject = rj
    })

    set(cacheAsync.current, key, promise)
    
    function _resolve(value) {
      resolve(value)
      return value
    }
    function _reject(error) {
      reject(error)
      set(cacheAsync.current, key, null)
    }
    return [promise, _resolve, _reject]
  }, [])

  const functional = useMemo(() => {
    return { getAsync, setAsync }
  }, [getAsync, setAsync])

  return [cacheAsync, functional]
}

export default useAsyncCache;